import type { ImagePath } from '@/core/lib/imageHelper';
import { getImage } from '@/core/lib/imageHelper';
import { getTranslated } from '@/core/lib/translationHelper';
import type { ITranslation } from '@/interface/ITranslation';
import { EnumLanguage } from '@/interface/enum';

type TeamName = ITranslation[] | undefined | string | null;

function normalizeTeamName(teamName: TeamName): string {
    if (!teamName) return '';

    return getTranslated(teamName, EnumLanguage.EN)
        .replaceAll(' ', '')
        .replaceAll('(PEN)', '')
        .replaceAll('(ET)', '');
}

export function getTeamImage(imageGlob: Record<string, unknown>, name: TeamName): ImagePath {
    const normalizedName = normalizeTeamName(name);
    const fallback = 'Unknown';

    if (!normalizedName) {
        return getImage(imageGlob, fallback, fallback);
    }

    return getImage(imageGlob, normalizedName, fallback);
}
